import { useNavigate } from 'react-router-dom';
import Dialog from '@/components/Dialog.tsx';

const AccessWarning = () => {
  const navigate = useNavigate();

  return (
    <Dialog
      title=""
      description={(
        <>
          To access the STUDY CENTER, you must be a SATPRAC COMPLETE MEMBER.
          Click on SATPRAC PACKAGES to UPGRADE and UNLOCK the study center, 100+ hours of video tutorials,
          MODULE MODE, and more!
        </>
      )}
      open
      onClose={() => navigate('/')}
      cancelText="Close"
    />
  );
};

export default AccessWarning;
